"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _reactGoogleCharts = require("react-google-charts");
var _utils = require("../../utils");
var _excluded = ["hAxisTitle", "options", "vAxisTitle"];
var ScatterChart = function ScatterChart(_ref) {
  var hAxisTitle = _ref.hAxisTitle,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? {} : _ref$options,
    vAxisTitle = _ref.vAxisTitle,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var theme = (0, _material.useTheme)();
  var textPrimary = theme.palette.text.primary;
  var textDisabled = theme.palette.text.disabled;
  return /*#__PURE__*/_react.default.createElement(_reactGoogleCharts.Chart, (0, _extends2.default)({
    chartType: "ScatterChart",
    options: (0, _utils.mergeDeep)({
      backgroundColor: 'transparent',
      hAxis: {
        baselineColor: textPrimary,
        gridlines: {
          color: textDisabled
        },
        minValue: 0,
        textStyle: {
          color: textPrimary
        },
        title: hAxisTitle,
        titleTextStyle: {
          color: textPrimary
        }
      },
      legend: 'none',
      vAxis: {
        baselineColor: textPrimary,
        gridlines: {
          color: textDisabled
        },
        minValue: 0,
        textStyle: {
          color: textPrimary
        },
        title: vAxisTitle,
        titleTextStyle: {
          color: textPrimary
        }
      }
    }, options)
  }, rest));
};
var _default = exports.default = ScatterChart;